import React from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import { object, bool } from 'prop-types'
import { Link } from 'react-scroll'
import { makeImgResizerUrl } from '@jelly/utils'

// Import Components
import { GtmDataLayerSetup, Layout } from '@jelly/components'
import Offerings from './Offerings'
import ApplicationForm from './ApplicationForm'
import Testimonials from './Testimonials'

const ConnectWrapper = styled.div`
	height: 100%;
	width: 100%;
`
const HeroBanner = styled.div`
	background: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};
	height: 100%;

	${({ theme }) => theme.MQ.M} {
		max-height: 467px;
		overflow: hidden;
		margin-bottom: 75px;
	}
`
const HeroContext = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto;
	text-align: left;
	width: 90%;

	${({ theme }) => theme.MQ.S} {
		flex-direction: row;
	}
	${({ theme }) => theme.MQ.XL} {
		${({ theme }) => theme.maxWidth.L};
	}
`
const Header = styled.h1`
	letter-spacing: -0.88px;
	line-height: 45px;
	font-size: 35px;
	font-weight: 300;
	margin: 0 0 17px;
	padding-top: 73px;

	${({ theme }) => theme.MQ.M} {
		line-height: 60px;
	}

	${({ theme }) => theme.MQ.L} {
		font-size: 45px;
	}
`
const HeroImage = styled.img`
	width: 100%;

	${({ theme }) => theme.MQ.S} {
		margin-top: auto;
		height: 100%;
		width: 350px;
	}

	${({ theme }) => theme.MQ.L} {
		width: 450px;
	}

	${({ theme }) => theme.MQ.XL} {
		width: 600px;
	}
`
const SubTitle = styled.h2`
	font-size: 20px;
	margin: 0 0 26px;
`
const CtaButton = styled(Link)`
	${({ theme }) => theme.buttons.default};
	margin: 30px 0 0 0;

	${({ theme }) => theme.MQ.S} {
		margin: 40px 0;
	}
`

const propTypes = {
	applicationForm: object.isRequired,
	hasVwo: bool,
	header: object,
	meta: object.isRequired,
	offerings: object.isRequired,
	testimonials: object.isRequired,
	theme: object.isRequired,
}

/**
 * This is the Connect Page index file
 * business.com/connect
 */
function ConnectPage({
	applicationForm,
	hasVwo,
	header: {
		cta = 'Get Started',
		title = 'Acquire more customers through business.com',
		subtitle = 'Reach millions of intent buyers at critical points in their sales journey',
	},
	meta,
	offerings,
	testimonials,
}) {
	return (
		<ConnectWrapper>
			<GtmDataLayerSetup contentType="connect" templateType="sales" />
			<Layout hasVwo={hasVwo} isOverlappingHero={true} meta={meta}>
				<HeroBanner>
					<HeroContext>
						<div>
							<Header dangerouslySetInnerHTML={{ __html: title }} />
							<SubTitle> {subtitle} </SubTitle>
							<CtaButton duration={700} offset={-100} smooth={true} to="pardot-form">
								{cta}
							</CtaButton>
						</div>
						<HeroImage
							className="lazyload"
							alt="Connect Page Advertise Hero Image - Featured Sponsor Spot"
							data-src={makeImgResizerUrl({
								src: 'https://www.business.com/images/pages/connect/connect-page-advertise.png',
								method: 'w',
								w: '700-png',
							})}
						/>
					</HeroContext>
				</HeroBanner>
				<Offerings {...offerings} />
				<Testimonials {...testimonials} />
				<ApplicationForm {...applicationForm} />
			</Layout>
		</ConnectWrapper>
	)
}

ConnectPage.propTypes = propTypes
export default withTheme(ConnectPage)
